import { useStore } from "vuex";
import { useRouter } from "vue-router";

interface NavItem {
  name: string;
  icon: string;
  link: string;
}

interface Navigation {
  category: string;
  items: NavItem[];
}

export const navItems: Navigation[] = [
  {
    category: "Allmänt",
    items: [
      { name: "Start", icon: "fa-house", link: "/admin" },
      { name: "Annonser", icon: "fa-briefcase", link: "/admin/positions" },
      { name: "Nyheter", icon: "fa-newspaper", link: "/admin/news" },
    ],
  },
  {
    category: "Inställningar",
    items: [
      {
        name: "E-postmallar",
        icon: "fa-envelope",
        link: "/admin/templates/email",
      },
      { name: "Annonsbilder", icon: "fa-image", link: "/admin/banners" },
      {
        name: "Formulärmallar",
        icon: "fa-clipboard-list",
        link: "/admin/form-templates",
      },
      {
        name: "Kompetenser",
        icon: "fa-user-graduate",
        link: "/admin/templates/skills",
      },
    ],
  },
  {
    category: "Admin",
    items: [
      { name: "Användare", icon: "fa-users", link: "/admin/users" },
      {
        name: "Företags Profil",
        icon: "fa-user",
        link: "/admin/container/profile",
      },
      { name: "Integration", icon: "fa-share", link: "/admin/integration" },
      { name: "GDPR", icon: "fa-gavel", link: "/admin/gdpr" },
      // { name: "Portalchatten", icon: "fa-comments", link: "/admin/chat" },
    ],
  },
  {
    category: "Superuser",
    items: [
      { name: "Events", icon: "fa-box", link: "/admin/events" },

      { name: "Skriv nyhet", icon: "fa-pencil", link: "/admin/create-news" },
      { name: "Ny Container", icon: "fa-box", link: "/admin/container/new" },
      {
        name: "Generera data",
        icon: "fa-database",
        link: "/admin/generate-data",
      },
    ],
  },
];

export const isVisible = (
  link: string,
  loggedInUserIsAdmin: boolean,
  loggedInUserIsWriter: boolean
): boolean => {
  const store = useStore();
  if (
    link == "/admin/create-news" ||
    link === "/admin/container/new" ||
    link === "/admin/generate-data" ||
    link === "/admin/create-news"
  ) {
    const role = store.state.userStore.token?.decoded?.role as string;
    if (typeof role === typeof undefined) {
      return false;
    }
    return role.includes("odin");
  } else if (
    ///link === "/events" ||
    link === "/admin/container/profile" ||
    link === "/admin/users" ||
    link === "/admin/gdpr" ||
    link === "/admin/integration" ||
    link === "/admin/events"
  ) {
    return loggedInUserIsAdmin;
  } else if (
    link === "/admin/templates/email" ||
    link === "/admin/banners" ||
    link === "/admin/templates/skills" ||
    link === "/admin/form-templates"
  ) {
    return loggedInUserIsWriter;
  }
  return true;
};

// function to handle class changes for selected nav item
export const navItemClass = (item: NavItem) => {
  const router = useRouter();

  if (
    item.link !== "/admin" &&
    router.currentRoute.value.path.includes(item.link)
  ) {
    return "bg-blue-4 text-blue-1";
  } else if (item.link === router.currentRoute.value.path) {
    return "bg-blue-4 text-blue-1";
  } else {
    return "text-darkGray-3 hover:bg-blue-4";
  }
};
